export default "__VITE_ASSET__dIvNCFa$__"